import { useCallback, useRef } from "react";
import FileUploadBtnContainer from "../../containers/FileUploadBtn";
import { StyledForm, SubmitButton, ButtonGroup, FormWrapper } from "./style";

const CardEditForm = (props) => {
  const { data, onAddOrUpdate, onDelete } = props;
  const { name, company, title, email, message, theme } = data;
  const nameRef = useRef();
  const companyRef = useRef();
  const themeRef = useRef();
  const titleRef = useRef();
  const emailRef = useRef();
  const messageRef = useRef();
  const formRef = useRef();

  const handleFileChange = useCallback(
    (result) => {
      const newValue = {
        ...data,
        fileName: result.name,
        filePath: result.url,
      };
      onAddOrUpdate(newValue);
    },
    [data, onAddOrUpdate]
  );

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.currentTarget == null) return;
    const newValue = {
      ...data,
      [event.currentTarget.name]: event.currentTarget.value,
    };
    onAddOrUpdate(newValue);
  };

  const handleDelete = (event) => {
    event.preventDefault();
    onDelete(data);
  };

  return (
    <FormWrapper>
      <StyledForm ref={formRef} onSubmit={(event) => event.preventDefault()}>
        <input
          onChange={handleInputChange}
          ref={nameRef}
          type="text"
          name="name"
          value={name}
          placeholder="이름"
          maxLength="8"
        />
        <input
          onChange={handleInputChange}
          ref={companyRef}
          type="text"
          name="company"
          value={company}
          placeholder="회사(소속)"
          maxLength="8"
        />
        <select
          onChange={handleInputChange}
          ref={themeRef}
          name="theme"
          value={theme}
        >
          <option value="light">light</option>
          <option value="dark">dark</option>
        </select>
        <input
          onChange={handleInputChange}
          ref={titleRef}
          type="text"
          name="title"
          value={title}
          placeholder="직업"
          maxLength="8"
        />
        <input
          onChange={handleInputChange}
          ref={emailRef}
          type="text"
          name="email"
          value={email}
          placeholder="이메일"
        />
        <textarea
          onChange={handleInputChange}
          ref={messageRef}
          name="message"
          value={message}
          cols="20"
          rows="2"
          placeholder="상태 메시지"
        ></textarea>
        <ButtonGroup>
          <FileUploadBtnContainer
            onFileChange={handleFileChange}
            fileName={data.fileName}
          />
          <SubmitButton btnType="Delete" type="button" onClick={handleDelete}>
            삭제하기
          </SubmitButton>
        </ButtonGroup>
      </StyledForm>
    </FormWrapper>
  );
};

export default CardEditForm;
